import {KTCard, KTSVG} from '../../../../../../_metronic/helpers'
import {useKorcaFormStore, useKorcaStore} from '../states/korca-management.state'
import {LoadingComponent} from '../../properties-management/components/loading.component'
import clsx from 'clsx'
import ReactPaginate from 'react-paginate'
import {useAuth} from '../../../../auth'
import {useEffect, useRef, useState} from 'react'
import {useNavigate} from 'react-router-dom'
import KorcaModalComponent from './korca-model.component'
import {FormAction} from '../../../../../interfaces/form-action-interfaces'

const KorcaListComponent = () => {
  const {getKorca, korcaItems, korcaLoading, korcaModel, onDelete} = useKorcaStore()
  const {setField, field, generateForms, submitDone, formLoading, reset} = useKorcaFormStore()
  const {currentUser} = useAuth()
  const [search, setSearch] = useState<string>('')
  const navigate = useNavigate()
  const [debounceQuery, setDebounceQuery] = useState<string>('')

  useEffect(() => {
    console.log(debounceQuery)
    getKorca({
      page: 0,
      size: 100,
    })
  }, [])

  const firstRender = useRef(true)
  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebounceQuery(search)
      if (firstRender.current) {
        firstRender.current = false
        return
      }
      getKorca({
        page: 0,
        size: 100,
        filters: `[
          ["email", "ilike", "${search}"], 
          ["or"],
          ["phone_number", "ilike", "${search}"],
          ["or"],
          ["full_name", "ilike", "${search}"],
          ["or"],
          ["district_name", "ilike", "${search}"]
        ]`,
      })
    }, 500)
    return () => {
      clearTimeout(timeout)
    }
  }, [search])

  useEffect(() => {
    if (submitDone === true && formLoading === false) {
      getKorca({page: 0, size: 100})
      reset()
    }
  }, [submitDone, formLoading])

  const handlePageClick = (e: any) => {
    const selectedPage = e.selected
    getKorca({page: selectedPage, size: 100})
  }

  return (
    <>
      <div className='py-5'>
        <div className='rounded border p-5' style={{backgroundColor: 'white'}}>
          <form
            data-kt-search-element='form'
            className='w-100 position-relative'
            autoComplete='off'
          >
            {/*begin::Hidden input(Added to disable form autocomplete)*/}
            <input type='hidden' />
            {/*end::Hidden input*/}
            {/*begin::Icon*/}
            {/*begin::Svg Icon | path: icons/duotune/general/gen021.svg*/}
            <span className='svg-icon svg-icon-2 svg-icon-lg-1 svg-icon-gray-500 position-absolute top-50 ms-5 translate-middle-y'>
              <KTSVG path='/media/icons/duotune/general/gen021.svg' className='svg-icon-2' />
            </span>
            {/*end::Svg Icon*/} {/*end::Icon*/}
            {/*begin::Input*/}
            <input
              type='text'
              className='form-control form-control-lg form-control-solid px-15'
              name='search'
              value={search}
              onChange={(e) => setSearch(e?.target?.value)}
              placeholder='Cari berdasarkan nama korca'
              data-kt-search-element='input'
            />
            {/*end::Input*/}
          </form>
        </div>
      </div>
      <KTCard>
        <div className='card-header border-0 pt-6'>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-bold fs-3 mb-1'>List Korca</span>
            <span className='text-muted mt-1 fw-semibold fs-7'>Korca Management</span>
          </h3>
          {currentUser?.data?.role?.slug === 'direksi' ? (
            ''
          ) : (
            <div className='card-toolbar'>
              <button
                type='button'
                className='btn btn-primary'
                onClick={(e) => {
                  e.preventDefault()
                  setField(null)
                  generateForms({
                    title: 'Add New Korca',
                    subtitle: 'Add New Korca',
                    action: FormAction.CREATE,
                  })
                }}
              >
                <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-2' />
                Add New Korca
              </button>
            </div>
          )}
        </div>
        <div className='card-body py-3'>
          <div className='table-responsive'>
            {korcaLoading ? <LoadingComponent /> : <></>}
            <table className='table table-row-bordered table-striped table-hover able-row-gray-100 align-middle gs-3 gy-3'>
              <thead>
                <tr className='text-start text-muted fw-bold fs-7 text-uppercase gs-0'>
                  <th>Korca Name</th>
                  <th>Wilayah</th>
                  <th className='text-end'>Actions</th>
                  <th className='text-end'>Detail</th>
                </tr>
              </thead>
              <tbody className='text-gray-600 fw-semibold'>
                {korcaItems.length === 0 ? (
                  <tr>
                    <td colSpan={4}>
                      <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                        No Properties Found
                      </div>
                    </td>
                  </tr>
                ) : (
                  korcaItems?.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td>
                          <div className='d-flex align-items-center'>
                            <div className='symbol symbol-circle symbol-50px overflow-hidden me-3'>
                              <a href='#'>
                                <div
                                  className={clsx(
                                    'symbol-label fs-3',
                                    `bg-light-success`,
                                    `text-success`
                                  )}
                                >
                                  {item?.full_name[0]}
                                </div>
                              </a>
                            </div>
                            <div className='d-flex flex-column'>
                              <a href='#' className='text-gray-800 text-hover-primary mb-1'>
                                {item?.full_name}
                              </a>
                            </div>
                          </div>
                        </td>
                        <td>{item?.district_name}</td>
                        <td className='text-end'>
                          {currentUser?.data?.role?.slug === 'superadmin' ||
                          currentUser?.data?.role?.slug === 'admin' ? (
                            <>
                              <a
                                href={`#`}
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                onClick={(e) => {
                                  e.preventDefault()
                                  setField(item)
                                  generateForms({
                                    title: 'Update Korca',
                                    subtitle: 'Update Korca',
                                    action: FormAction.UPDATE,
                                    data: item,
                                    id: item.id,
                                  })
                                }}
                              >
                                <KTSVG
                                  path='/media/icons/duotune/art/art005.svg'
                                  className='svg-icon-3'
                                />
                              </a>
                              <a
                                href='#'
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                                onClick={(e) => {
                                  e.preventDefault()
                                  onDelete(item.id, {
                                    page: 0,
                                    size: 100,
                                  })
                                }}
                              >
                                <KTSVG
                                  path='/media/icons/duotune/general/gen027.svg'
                                  className='svg-icon-3'
                                />
                              </a>
                            </>
                          ) : (
                            <></>
                          )}
                        </td>
                        <td className='text-end'>
                          <button
                            className='btn btn-success'
                            onClick={(e) => {
                              e.preventDefault()
                              navigate(`/apps/korca-management/korca-detail/${item.id}`)
                            }}
                          >
                            Detail
                          </button>
                        </td>
                      </tr>
                    )
                  })
                )}
              </tbody>
            </table>
          </div>

          <div className='card-footer'>
            <ReactPaginate
              previousLabel={'«'}
              nextLabel={'»'}
              breakLabel={'...'}
              breakClassName={'page-item'}
              breakLinkClassName={'page-link'}
              previousClassName={'page-item'}
              previousLinkClassName={'page-link'}
              nextClassName={'page-item'}
              nextLinkClassName={'page-link'}
              pageCount={korcaModel?.data?.total_pages}
              marginPagesDisplayed={2}
              pageRangeDisplayed={10}
              onPageChange={handlePageClick}
              containerClassName={'pagination pagination-sm m-0 float-right'}
              pageClassName={'page-item'}
              pageLinkClassName={'page-link'}
              activeClassName={'active'}
            />
          </div>
        </div>
      </KTCard>
      {field !== undefined && <KorcaModalComponent />}
    </>
  )
}

const KorcaListWrapper = () => {
  return (
    <>
      <KorcaListComponent />
    </>
  )
}
export {KorcaListWrapper}
